import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditWhyChooseUsItem from "../../components/why-choose-us/FormAddEditWhyChooseUsItem";

const CreateWhyChooseUsItem = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/why-choose-us");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditWhyChooseUsItem
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateWhyChooseUsItem;
